import localForage from 'localforage';
import { logoutAPI } from '@/api/login';

export async function performLogout(additionalTokens: string[] = []): Promise<void> {
    try {
        if (additionalTokens.length) {
            await logoutAPI({
                additional_tokens: additionalTokens,
                all_sessions: 'false',
            });
        }
    } catch {
        // ignore server‐side logout failures
    }
    await localForage.clear();
    localStorage.removeItem('userDetails');
    localStorage.removeItem('isUserLogin');
    localStorage.removeItem('corporationDetails');
    localStorage.removeItem('tokenExpires');
    localStorage.removeItem('hasCorporateSession');
    localStorage.removeItem('manageStoreId');
    localStorage.removeItem('manageStoreName');
    localStorage.removeItem('hasMultiStore');
}
